import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { debounce, get, isNull, map, size } from 'lodash';
import { Form, Scope } from 'informed';
import axios from 'axios';
import DeleteButton from '../../components/DeleteButton';
import Alert from '../../components/Alert';
import { BaseForm } from '../../base';
import { InputSelect } from '../../components/inputs';
import { API_HOST } from '../../consts';
import NxtButton from '../../components/NxtButton';
import PrevButton from '../../components/PrevButton';
import Loading from '../../components/Loading';
import { getCompetencias, getHabilidades } from '../../utils';
import AddReferencia from '../../components/buttons/AddReferencia';
import FormContainer from '../../containers/Form';
import { TrackGoogleAnalyticsEvent } from '../../utils/googleAnalytics';
import { ClickMatrizReferenciaObject, ClickMatrizReferenciaObjectAction } from '../../utils/googleAnalytics/events/Itens/EventMatrizReferenciaObject';

const mapCompetencia = (c) => ({
  value: c.id,
  label: c.descricao,
  ...c
});

class MatrizReferencia extends BaseForm {
  constructor(props) {
    super(props);
    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addMatrizReferencia = this.addMatrizReferencia.bind(this);
    this.formApis = {};
    this.fields = ['matriz_referencia'];
    this.multiFields = ['competencias'];
  }

  state = {
    matrizes_referencia: [],
    matriz_referencia: [],
    area_conhecimento_ids: [],
    competencia: [],
    habilidade: [],
    objetoConhecimento: [],
    fetchingData: true,
    fetchingItem: true,
    fetchingMatrizesReferencia: true,
    showNoMatrizReferenciaAlert: true,
    save: this.ATUALIZADO,
    markedForDeletion: [],
    fatched: false,
    habilidadeSearch: '',
    matriz_id: ''
  };

  metadataModels = ['item'];

  componentDidMount() {
    this.fetchMetadata().then(() => {
      this.fetchItem();
      this.fetchData();
      this.fetchMe();

    });
  }

  fetchHabilidade = debounce((matrizId) => {
    const { item } = this.props;
    const { habilidadeSearch, matriz_id } = this.state
    const matriz = matriz_id ? (matriz_id) : (matrizId);

    axios
      .get(
        `${API_HOST}/matriz_referencia/habilidade?matriz_id=${matriz}&area_conhecimento_id=${this.state.area_conhecimento_ids
        }&disciplina=${item && item.componente_curricular}&etapa_id=${item && item.periodo
        }&search=${habilidadeSearch}`
      )
      .then((response) => {
        const data = response.data.results;
        this.setState({
          fatched: true,
          habilidade: data.map((e) => ({
            value: e.id,
            label: `${e.cd_habilidade} - ${e.ds_habilidade}`
          }))
        });
      });
  }, 600);

  fetchMatrizesReferencia() {
    const { area_conhecimento_ids } = this.state;
    const params = {
      status: 1,
      page_size: 100
    };

    if (this.shouldDisplay('item.areas_conhecimento')) {
      params.areas_conhecimento__id = area_conhecimento_ids.join('|');
    }

    const { item } = this.props;
    const cursoId = item && item.curso ? item.curso : '';

    axios
      .get(
        `${API_HOST}/matriz_referencia/matriz_referencia?curso__id=${cursoId}`,
        { params }
      )
      .then((response) => {
        const data = response.data.results ? response.data.results : response.data;
        this.setState({
          matriz_referencia: data.map((x) => ({
            value: x.id,
            label: x.descricao,
            // objetoConhecimento : x.objeto_conhecimento,
            ...x
          })),
          fetchingMatrizesReferencia: false
        });
      });
  }
  fetchMe() {
    const token = localStorage.getItem('token');
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data.id });
      })
      .catch((response) => console.error(response.error));
  }

  fetchItem() {
    axios.get(`${API_HOST}/itens/item/${this.id}`).then((response) => {
      const { tipo, areas_conhecimento, area_conhecimento_ids, exame } =
        response.data;
      this.setState(
        {
          tipo,
          areas_conhecimento,
          area_conhecimento_ids,
          exame,
          criado_por: response.data.criado_por_ids,
          fetchingItem: false
        },
        this.fetchMatrizesReferencia
      );
    });
  }

  fetchData() {
    this.callApi = false;

    axios
      .get(`${API_HOST}/itens/item_matriz_habilidade/form`, {
        params: {
          item: this.id
        }
      })
      .then((response) => {
        this.setState(
          {
            matrizes_referencia: response.data,
            fetchingData: false
          },
          () => {
            response.data.forEach(() => {
              this.formApi.setValues({ matrizes_referencia: response.data });
            });
            setTimeout(() => {
              this.callApi = true;
            }, 1000);
          }
        );
      });
  }
  fetchObjetoConhecimento(e) {
    this.callApi = false;

    const { item } = this.props;
    axios
      .get(
        `${API_HOST}/matriz_referencia/objeto_conhecimento?matriz_id=${e}&area_conhecimento_id=${this.state.area_conhecimento_ids
        }&disciplina=${item && item.componente_curricular}&etapa_id=${item && item.periodo
        }`
      )
      .then((response) => {
        const data = response.data;
        this.setState({
          fatched: true,
          objetoConhecimento: data.map((e) => ({
            value: e.id,
            label: `${!isNull(e.tema) ? e.tema + ' - ' : ''}${e.topico} ${!isNull(e.subtopico) ? e.subtopico + ':' : ''} ${!isNull(e.campo_atuacao) ? e.campo_atuacao : ''}`
          }))
        });
      });
  }

  renderEmptyState() {
    const { matrizes_referencia } = this.state;

    if (matrizes_referencia.length === 0) {
      return (
        <div>
          <hr />
          <div>
            <p>
              Este objeto de aprendizagem ainda não possui nenhuma matriz de
              referência.
            </p>
          </div>
        </div>
      );
    }
    return '';
  }

  add() {
    const { matrizes_referencia } = this.state;
    this.setState({
      matrizes_referencia: [{ id: null }].concat(matrizes_referencia)
    });
  }

  remove(id) {
    axios.delete(`${API_HOST}/itens/item_matriz_referencia/${id}`).then(() => {
      const { matrizes_referencia } = this.state;
      this.setState({
        matrizes_referencia: matrizes_referencia.filter((x) => x.id !== id)
      });
    });
  }

  addHabilidades(i) {
    this.setState({ save: this.MODIFICADO });
    const { values } = this.formApi.getState();
    const habilidades = get(
      values,
      `matrizes_referencia[${i}].habilidades`,
      []
    ).concat([{}]);
    values.matrizes_referencia[i].habilidades = habilidades;
    this.formApi.setValues({ ...values });
  }

  addMatrizReferencia() {
    this.setState({ save: this.MODIFICADO });
    const { values } = this.formApi.getState();
    const matrizes_referencia = get(values, 'matrizes_referencia', []).concat([
      {}
    ]);
    this.formApi.setValues({ matrizes_referencia });
  }

  removeHabilidades(i, j) {
    this.setState({ save: this.MODIFICADO });
    const { values } = this.formApi.getState();
    values.matrizes_referencia[i].habilidades.splice(j, 1);
    this.formApi.setValues({ ...values });
  }

  removeMatrizReferencia(m, i) {
    if (m.id) {
      const { markedForDeletion } = this.state;
      markedForDeletion.push(m.id);
      this.setState({ markedForDeletion });
    }

    const { values } = this.formApi.getState();
    values.matrizes_referencia.splice(i, 1);
    this.formApi.setValues({ ...values });
  }

  handleSubmit(next) {
    const { values } = this.formApi.getState();
    const matrizes_referencia = get(values, 'matrizes_referencia') || [];
    const { history } = this.props;
    if (matrizes_referencia.length === 0) {
      history.push(next);
      return;
    }

    const data = matrizes_referencia.map((d) => ({
      ...d,
      item: this.id
    }));

    const { markedForDeletion } = this.state;
    axios.post(`${API_HOST}/itens/item_matriz_habilidade`, data).then(() => {
      const { history } = this.props;
      history.push(next);
    });
  }
  getHabilidades(m, c) {
    const { matriz_referencia } = this.state;

    return getHabilidades(matriz_referencia, m, c);
  }

  showNoAreaConhecimentoSelectedMessage() {
    const { area_conhecimento_ids, matrizes_referencia } = this.state;
    const areaConhecimentoEnabled = this.shouldDisplay(
      'item.areas_conhecimento'
    );
    return areaConhecimentoEnabled && size(area_conhecimento_ids) === 0;
  }

  showNoAreaConhecimentoAvailableMessage() {
    const {
      showNoMatrizReferenciaAlert,
      fetchingMatrizesReferencia,
      matriz_referencia
    } = this.state;
    const areaConhecimentoEnabled = this.shouldDisplay(
      'item.areas_conhecimento'
    );
    return (
      areaConhecimentoEnabled &&
      showNoMatrizReferenciaAlert &&
      !fetchingMatrizesReferencia &&
      size(matriz_referencia) === 0
    );
  }

  analytcsClick = (name, type) => {
    let label = "Click" + ": " + name;
    let category = ClickMatrizReferenciaObject + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickMatrizReferenciaObjectAction,
      label,
    );
  };


  render() {
    const {
      matriz_referencia,
      fetchingData,
      fetchingMetadata,
      fetchingItem,
      fetchingMatrizesReferencia,
      habilidadeSearch
    } = this.state;


    const { isDisabled } = this.props;

    return (
      <div>
        <Form
          getApi={(formApi) => {
            this.formApi = formApi;
          }}
          initialValues={{
            matrizes_referencia: []
          }}
        >
          {({ formState }) => {
            if (
              fetchingData ||
              fetchingMetadata ||
              fetchingItem ||
              fetchingMatrizesReferencia
            ) {
              return <Loading />;
            }

            // if (this.showNoAreaConhecimentoSelectedMessage()) {
            //   return (
            //     <div>
            //       <p className="text-center text-normal">
            //         <i className="fas fa-info-circle" /> Por favor, antes de
            //         prosseguir, <Link to="dados">clique aqui</Link> para definir
            //         uma área de conhecimento.
            //       </p>
            //     </div>
            //   );
            // }

            return (
              <FormContainer
                title="Matriz de referência"
              >
                <React.Fragment>
                  {this.showNoAreaConhecimentoAvailableMessage() && (
                    <div className="row">
                      <div className="col-md-12 padding-15">
                        <Alert
                          category="warning"
                          onClick={() =>
                            this.setState({ showNoMatrizReferenciaAlert: false })
                          }
                        >
                          Nenhuma matriz de referência relacionada às áreas de
                          conhecimento do objeto de aprendizagem.
                        </Alert>
                      </div>
                    </div>
                  )}
                  {this.showNoAreaConhecimentoSelectedMessage() && (
                    <div>
                      <p className="text-center text-normal">
                        <i className="fas fa-info-circle" /> Por favor, antes de
                        prosseguir, <Link to="dados">clique aqui</Link> para definir
                        uma área de conhecimento.
                      </p>
                    </div>
                  )}

                  {map(formState.values.matrizes_referencia, (m, i) => (
                    <Scope scope={`matrizes_referencia[${i}]`}>
                      <div className="card matriz-referencia mt-3">
                        <div className="card-body" style={{ backgroundColor: '#fff', borderRadius: '8px' }}>
                          <div className="row" style={{ backgroundColor: '#fff', borderRadius: '8px' }}>
                            <InputSelect
                              disabled={isDisabled}
                              col="col-sm-12"
                              label="Matriz de Referência"
                              field="matriz_referencia"
                              options={matriz_referencia}
                              clearable={true}
                              onChange={(e) => {
                                if (e) {
                                  this.analytcsClick(`Matriz de Referência: ${e.label}`, "InputSelect: Matriz de Referência Selected Value")
                                  this.setState({ matriz_id: e.value });
                                  this.fetchObjetoConhecimento(e.value);
                                  this.fetchHabilidade()
                                }
                                else {
                                  this.analytcsClick(`Matriz de Referência: Excluído`, "InputSelect: Matriz de Referência Remove Value")
                                }
                              }}
                            />


                          </div>

                          {m.matriz_referencia &&
                            (!m.habilidades || m.habilidades.length < 1) ? (
                            <div className="row">
                              <div className="col-md-12">
                                <button
                                  className="sc-AxiKw coUCbo btn mb-3 ml-3"
                                  onClick={() => this.addHabilidades(i)}
                                >
                                  <i className="fas fa-plus" /> Adicionar
                                  habilidade
                                </button>
                              </div>
                            </div>

                          ) : (
                            <></>
                          )}

                          {get(
                            formState,
                            `values.matrizes_referencia[${i}].habilidades`,
                            []
                          ).length > 0 && <hr />}
                          {map(
                            formState.values.matrizes_referencia[i].habilidades,
                            (c, j) => (
                              <React.Fragment>
                                <div className="row">
                                  <Scope scope={`competencias[${j}]`}>
                                    <InputSelect
                                      disabled={isDisabled}
                                      selected={
                                        formState.values.matrizes_referencia[i]
                                          .habilidades[0]
                                      }
                                      col="col-sm-12"
                                      label="Habilidades"
                                      field="habilidades"
                                      onChange={(event) => {
                                        if (!event) {
                                          this.setState({ habilidadeSearch: '' })
                                          this.fetchHabilidade(m.matriz_referencia)
                                          this.analytcsClick(`Habilidades: Excluído`, "InputSelect: Habilidades Remove Value")
                                        }
                                        else {
                                          this.analytcsClick(`Habilidades: ${event.label}`, "InputSelect: Habilidades Selected Value")
                                        }
                                      }}
                                      onInputChange={(event) => {
                                        if (event) {
                                          this.setState({ habilidadeSearch: event })
                                          this.fetchHabilidade(m.matriz_referencia)
                                        }
                                      }}
                                      options={
                                        this.state.fatched
                                          ? this.state.habilidade
                                          : formState.values.matrizes_referencia[
                                            i
                                          ].habilidades

                                      }
                                    />

                                  </Scope>
                                </div>
                                {/* {i <
                                formState.values.matrizes_referencia[i]
                                  .competencias.length -
                                  1 && <hr />} */}
                              </React.Fragment>
                            )
                          )}
                        </div>

                        <div style={{ background: '#ffff', borderRadius: '8px' }}>
                          <InputSelect
                            disabled={isDisabled}


                            selected={
                              formState.values.matrizes_referencia[0]
                                .objeto_conhecimento ? formState.values.matrizes_referencia[0]
                                  .objeto_conhecimento[0] : { 'value': 0, label: 'Selecione ...' }
                            }
                            col="col-sm-12"
                            label="Objetos de Conhecimento"
                            field="objetoConhecimento"
                            options={
                              this.state.fatched
                                ? this.state.objetoConhecimento
                                : formState.values.matrizes_referencia[0].objeto_conhecimento}

                            clearable={false}
                            onChange={(event) => {
                              if (event) {
                                this.analytcsClick(`Objetos de Conhecimento: ${event.label}`, "InputSelect: Objetos de Conhecimento Selected Value")
                              }
                              else {
                                this.analytcsClick(`Objetos de Conhecimento: Excluído`, "InputSelect: Objetos de Conhecimento Remove Value")
                              }
                            }}
                          />
                          <div>
                            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'right', paddingRight: '4px', marginBottom: '5px' }}>
                              <button
                                disabled={isDisabled}
                                onClick={() => this.removeMatrizReferencia(m, i)}
                                style={{
                                  backgroundColor: '#E96240', border: 'none', outline: 'none', padding: '0px, 6px, 0px, 6px',
                                  borderRadius: '8px', color: 'white', marginRight: '14px'
                                }}>
                                Excluir
                              </button>
                            </div>
                          </div>
                        </div>

                      </div>

                    </Scope>
                  ))}
                  <div className="row">

                    <AddReferencia
                      disabled={isDisabled}
                      title="Adicionar matriz/habilidade"
                      onClick={this.addMatrizReferencia}
                      backgroundType='action'
                    />

                  </div>
                  <div className="row pull-right mt-2 mb-2">
                    <div className="col-md-12">
                      <PrevButton
                        to="dados"
                        onClick={() => this.handleSubmit('dados')}
                      />
                      <NxtButton
                        onClick={() =>
                          this.handleSubmit('referencias-bibliograficas')
                        }
                      />
                    </div>
                  </div>
                </React.Fragment>
              </FormContainer>
            );
          }}
        </Form>
      </div>
    );
  }
}

export default withRouter(MatrizReferencia);
